import styled from 'styled-components'

import ButtonArrow from '../assets/REDESIGN_Assets/UserWizzard/button_arrow.png'
import ButtonGreenSmallArrow from '../assets/REDESIGN_Assets/UserProfile/arrow-icon.png'

const GenericButton = styled.button`
  width: ${(props) => (props.width ? props.width : '100%')};
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.justify ? props.justify : 'left')};
  flex-direction: row;
  padding: ${(props) => (props.padding ? props.padding : '20px 40px')};
  position: ${(props) => (props.position ? props.position : 'relative')};
  top: ${(props) => (props.top ? props.top : 'unset')};
  left: ${(props) => (props.left ? props.left : 'unset')};
  right: ${(props) => (props.right ? props.right : 'unset')};
  bottom: ${(props) => (props.bottom ? props.bottom : 'unset')};
  font-family: 'Nunito';
  font-size: ${(props) => (props.fSize ? props.fSize : '1.1rem')};
  z-index: ${(props) => (props.zIndex ? props.zIndex : '1')};
  /* font-weight: normal; */
  font-stretch: normal;
  font-style: normal;
  /* line-height: 1.53; */
  letter-spacing: -0.38px;
  text-align: center;
  color: #342152;
  border-radius: ${props => props.borderRadius ? props.borderRadius : "19px"};
  border: 1px solid transparent;
  box-sizing: border-box;
  font-family: 'Nunito';
  font-weight: ${(props) => (props.fWeight ? props.fWeight : 'normal')};
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.32px;
  text-align: ${(props) => (props.tAlign ? props.tAlign : 'left')};
  margin: ${(props) => (props.margin ? props.margin : '5px 0;')};
  color: #1b0f25;
  transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  cursor: pointer;
  border: none;
  outline: none;
  box-shadow: 1.4px 2.8px 1.8px -30px rgba(0, 0, 0, 0.014),
    3.3px 6.7px 4.3px -30px rgba(0, 0, 0, 0.02),
    6.3px 12.5px 8px -30px rgba(0, 0, 0, 0.025),
    11.2px 22.3px 14.3px -30px rgba(0, 0, 0, 0.03),
    20.9px 41.8px 26.7px -30px rgba(0, 0, 0, 0.036),
    50px 100px 64px -30px rgba(0, 0, 0, 0.05);

  @media only screen and (max-width: 1700px) {
    font-size: 1.3rem;
    /* padding: 10px; */
  }
  @media only screen and (max-width: 1500px) {
    font-size: 1.2rem;
    /* padding: 10px; */
  }
  @media only screen and (max-width: 1400px) {
    font-size: 1.2rem;
    /* padding: 10px; */
  }
  @media only screen and (max-width: 1300px) {
    font-size: 1.1rem;
    /* padding: 10px; */
  }
  @media only screen and (max-width: 600px) {
    padding: 4% 10px;
    font-size: 1.4rem;
  }

  .button-span{
    width:100%;
    display: block;
    text-align: center;
  }

  &.landing-videos-section-button{



 font-size: 0.8rem !important;
  white-space: nowrap;

}



  &:hover {
    transform: scale(1.05);
    box-shadow: 0 1.5px 1.9px -12px rgba(0, 0, 0, 0.022),
      0 3.7px 4.5px -12px rgba(0, 0, 0, 0.032),
      0 7px 8.5px -12px rgba(0, 0, 0, 0.04),
      0 12.5px 15.2px -12px rgba(0, 0, 0, 0.048),
      0 23.4px 28.4px -12px rgba(0, 0, 0, 0.058),
      0 56px 68px -12px rgba(0, 0, 0, 0.08);
  }

  &.with-arrow {
    &:after {
      content: '';
      background: url(${ButtonArrow});
      position: absolute;
      right: 10%;
      top: calc(50% - 0.65vh);
      width: 1.1vw;
      height: 1.3vh;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;

      @media only screen and (max-width: 600px) {
        width: 3.5vw;
        height: 3.5vh;
        top: calc(50% - 1.75vh);
      }
    }
  }

  &.with-green-arrow {
    &:after {
      content: '';
      background: url(${ButtonGreenSmallArrow});
      position: absolute;
      right: 10%;
      top: calc(50% - 0.65vh);
      width: 0.8vw;
      height: 1.3vh;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;

      @media only screen and (max-width: 600px) {
        width: 1.8vw;
        height: 1.8vh;
        top: calc(50% - 0.9vh);
      }
    }
  }

  &.inactive {
    opacity: 0.2;

    &:hover {
      transform: none;
      cursor: not-allowed;
    }
  }

  &.danger {
    background-color: #dc143c;
    color: white;
  }

  &.standard {
    background-color: #a1ff68;
  }

  &.navy {
    background-color: #342152;
    color: white;
  }

  &.facebook {
    background-color: #5868bb;
    color: white;
  }

  &.gradient {
    background-color: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: white;
    box-shadow: 2.8px 2.8px 2.2px rgba(0, 0, 0, 0.008),
      6.7px 6.7px 5.3px rgba(0, 0, 0, 0.012),
      12.5px 12.5px 10px rgba(0, 0, 0, 0.015),
      22.3px 22.3px 17.9px rgba(0, 0, 0, 0.018),
      41.8px 41.8px 33.4px rgba(0, 0, 0, 0.022),
      100px 100px 80px rgba(0, 0, 0, 0.03);
  }

  &.promo-fill-btn {
    border: 1px solid rgb(161, 251, 104);
    background-color: rgb(161, 251, 104);
    text-align: center;
    color: #342152;
    justify-content: center;

    @media (max-width: 768px) {
      font-size: 1.2rem;
    }
  }

  &.promo-outline-btn {
    border: 1px solid rgb(161, 251, 104);
    background-color: transparent;
    text-align: center;
    color: rgb(161, 251, 104);
    justify-content: center;

    @media (max-width: 768px) {
      font-size: 1.2rem;
    }
  }

  &.no-borders-btn{
    width: max-content;
    padding: 5px 40px;
    background-color: transparent;
    color: white;
  }

  &.promo-banner-filled-btn {
    width: max-content;
    padding: 5px 40px;
    background-color: #342152;
    font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  color: #fff;
  }


`

export default GenericButton
